import {Component, OnInit} from '@angular/core';
import {ActivatedRoute, Router} from '@angular/router';
import {AuthTokenService} from '../../../shared/services/auth-token.service';
import {SurveyService} from './../surveys.service';
import {SurveyCreatePDModel, SurveyTabs} from './../../../models/survey/survey.model';
import {DataTransferService} from './../../../shared/services/data-transfer.service';
import {PreviousUrlService} from '../../../shared/services/previous-url.service';
import {Toast, ToasterService} from 'angular5-toaster/dist';
import {CommunicationService} from '../../../shared/services/communication.service';
import { Location } from '@angular/common';

@Component({
  selector: 'app-new-survey',
  templateUrl: './new-survey.component.html',
  styleUrls: ['./new-survey.component.less']
})
export class NewSurveyComponent implements OnInit {

  activeTab: number;
  previousTab: number;
  withdrawBtn: boolean;
  showLoader: boolean;

  surveyCreatePDModelInitial: string;
  surveyCreatePDModel: SurveyCreatePDModel;
  fromSelectedPeople: boolean;
  dropdown = false;
  surveyTabs = SurveyTabs;
  surveyId: number;
  surveyTitle: string;
  surveyStatus: number;
  isAdmin = AuthTokenService.isAdmin();
  isCustomerAdmin = AuthTokenService.isCustomerAdmin();
  routeBack: string;

  constructor(private router: Router,
              private toasterService: ToasterService,
              private route: ActivatedRoute,
              public surveyService: SurveyService,
              private shareService: PreviousUrlService,
              private communicationService: CommunicationService,
              private location: Location) {
    this.route.params.subscribe();
  }

  navigateToSurveyAnalysis() {
    this.surveyService.resetSmartAnalysisResults();
    this.router.navigate(['/surveys/master-summary/' + this.surveyId]);
  }

  ngOnInit() {

    this.surveyService.questionsHierarchy = null;
    this.surveyService.surveyCreatePDModel = null;

    this.showLoader = true;
    this.surveyId = parseInt(this.route.snapshot.paramMap.get('id'));
    this.surveyTitle = this.route.snapshot.paramMap.get('title');
    this.shareService.setSurveyTitle(this.surveyTitle);
    this.withdrawBtn = false;
    this.surveyService.surveyCreatePDModel = DataTransferService.PullData('SurveyCreatePDModel');

    if (this.surveyService.surveyCreatePDModel === null) {
      this.surveyService.surveyCreatePDModel = new SurveyCreatePDModel();
      // console.log('add new');
      this.fromSelectedPeople = false;
    } else {
      // console.log('from people');
      this.fromSelectedPeople = true;
    }

    if (this.surveyId) {
      this.surveyService.getSurvey(this.surveyId).subscribe(
        (response) => {
          // console.log(response);
          this.surveyService.surveyCreatePDModel = response;
          this.surveyCreatePDModelInitial = JSON.stringify(this.surveyCreatePDModel);

          this.activeTab = 4;
          this.previousTab = 4;

          this.showLoader = false;
          this.surveyStatus = this.surveyService.surveyCreatePDModel.status;
          this.shareService.setSurveyTitle(response.title);
        },
        (error) => {
          this.showLoader = false;

        }
      );
    } else {
      this.surveyService.defineNewSurvey(this.surveyService.surveyCreatePDModel).subscribe(
        (response) => {
          this.surveyService.surveyCreatePDModel = response;

          this.activeTab = 4;
          this.previousTab = 4;
          this.showLoader = false;
        },
        (error) => {
          this.showLoader = false;
          // console.log(error);
        }
      );
    }


  }

  getHeight(e) {
    console.log(e);
  }


  changeTab(index) {
    if (this.updateSurveyModel(this.surveyService.surveyCreatePDModel, this.activeTab)) {
      this.previousTab = this.activeTab;
      this.activeTab = index;

      if (index === 4) {
        this.communicationService.toggleSidemenu.next();
      }
    }
  }

  showNextPart(activeTab) {
    this.previousTab = this.activeTab;
    this.activeTab++;

    if (activeTab === 5) {
      this.withdrawBtn = true;
      this.activeTab = 5;
    }
  }


  returnToSurveys() {
    this.router.navigate(['surveys']);
  }

  OLDupdateSurveyModel(surveyModel) {
    if (this.surveyCreatePDModelInitial == JSON.stringify(this.surveyCreatePDModel)) {
      return false;
    }

    // this can happen only when survey is created
    if (this.surveyService.surveyCreatePDModel.id > 0) {
      this.showLoader = true;
      this.surveyService.surveyCreatePDModel = surveyModel;
      this.surveyService.save(this.surveyService.surveyCreatePDModel).subscribe(
        (response) => {
          this.surveyService.surveyCreatePDModel = response;
          this.surveyCreatePDModelInitial = JSON.stringify(this.surveyService.surveyCreatePDModel);
          this.surveyService.surveyCreatePDModel.clientName = this.surveyService.surveyCreatePDModel.listClientModel.find(a => a.id == this.surveyService.surveyCreatePDModel.clientId).name;

          this.showLoader = false;
        },
        (error) => {
          // console.log(error);
          this.showLoader = false;
        }
      );
    }


  }

  updateSurveyModel(surveyModel, tabId) {
    this.surveyService.surveyCreatePDModel = surveyModel;
    let valid = true;

    switch (this.activeTab) {

      case 1:
        if (this.surveyService.surveyCreatePDModel.title == null || this.surveyService.surveyCreatePDModel.title == '') {
          const toast: Toast = {
            type: 'error',
            title: 'Error',
            body: 'Survey Title is mandatory',
            showCloseButton: true,
            timeout: 5000
          };
          this.toasterService.pop(toast);
          valid = false;
        }

        if (this.surveyService.surveyCreatePDModel.clientId == null || this.surveyService.surveyCreatePDModel.clientId == 0) {
          if (this.surveyService.surveyCreatePDModel.clientName == null || this.surveyService.surveyCreatePDModel.clientName == '') {
            const toast: Toast = {
              type: 'error',
              title: 'Error',
              body: 'Client is mandatory',
              showCloseButton: true,
              timeout: 5000
            };
            this.toasterService.pop(toast);
            valid = false;
          }
        }
        if (this.surveyService.surveyCreatePDModel.maximumNumberParticipants < 1) {
          const toast: Toast = {
            type: 'error',
            title: 'Error',
            body: 'Maximum number of participants must be greater then 0',
            showCloseButton: true,
            timeout: 5000
          };
          this.toasterService.pop(toast);
          valid = false;
        }
        break;
      case 2:
        break;
      case 3:
        break;
      case 4:
        if (this.surveyService.surveyCreatePDModel.id > 0) {
          if (this.surveyService.questionsHierarchy) {
            this.surveyService.sortListSurveyQuestionModel();
          }
          for (let q of this.surveyService.surveyCreatePDModel.listSurveyQuestionModel) {
            if (parseInt(q.answerType) == 0 || q.answerType == null || q.question == null || q.question == '') {
              const toast: Toast = {
                type: 'error',
                title: 'Error',
                body: 'Answer type and question are mandatory: \'' + q.question + '\'',
                showCloseButton: true,
                timeout: 5000
              };
              this.toasterService.pop(toast);
              valid = false;
            }

            if (q.answerType == 'SingleChoice' || q.answerType == 'MultipleChoice' || q.answerType == 'Dropwdown' || q.answerType == 'YesNo' || q.answerType == 'PictureChoice') {
              for (let a of q.listSurveyQuestionAnswerModel) {
                if (a.answer == null || a.answer == '' || a.answer == undefined) {
                  const toast: Toast = {
                    type: 'error',
                    title: 'Error',
                    body: 'Answer text is mandatory: \'' + q.question + '\'',
                    showCloseButton: true,
                    timeout: 5000
                  };
                  this.toasterService.pop(toast);
                  valid = false;
                }
              }
            }
          }
        }
        break;
      case 5:
        break;
      case 6:
        break;
    }
    if (this.isAdmin && valid && this.activeTab !== 7) {
      const isNew = this.surveyService.surveyCreatePDModel.id === 0;
      this.showLoader = true;
      this.surveyService.surveyCreatePDModel.tabId = tabId;
      this.surveyService.save(this.surveyService.surveyCreatePDModel).subscribe(
        (response) => {
          this.surveyService.surveyCreatePDModel = response;
          this.showLoader = false;

          if (isNew) {
            this.router.navigate(['/surveys/new/' + this.surveyService.surveyCreatePDModel.id + '/' + this.surveyService.surveyCreatePDModel.title.replace(/\(/g, '[').replace(/\)/g, ']')]);
          }

        },
        (error) => {
          // console.log(error);
          this.showLoader = false;
        }
      );
    }
    return valid;

  }

  setSurveyModelFromQuestionTab(surveyModel) {
    this.surveyService.surveyCreatePDModel = surveyModel;
  }

  onClickOutsideType(event: Object) {
    if (event && event['value'] === true) {
      this.dropdown = false;
    }
  }

  toggleDropdown() {
    this.dropdown = !this.dropdown;
  }

  isAdminRole() {
    return this.isAdmin || this.isCustomerAdmin;
  }
}



// WEBPACK FOOTER //
// ./src/app/routes/surveys/new-survey/new-survey.component.ts